/**
 *
 * Asynchronously loads the component for Admin
 *
 */

import { lazyLoad } from 'utils/loadable';

export const LogsPage = lazyLoad(
  () => import('./index'),
  module => module.LogsPage,
);
